import { Camera, Check, ShieldCheck } from 'lucide-react';
export function PrivacyScreen({onAccept,onBack}:{onAccept:()=>void;onBack:()=>void}){
  return <main className="screen centre-page"><section className="dialog-card privacy-card">
    <div className="icon-bubble"><ShieldCheck/></div><h1>安心使用鏡頭</h1>
    <div className="privacy-lines"><p><Check/>相機畫面只會在這部 iPad 上用來辨識身體動作。</p><p><Check/>系統不會拍照、錄影或上載影像。</p><p><Check/>活動完結後不會保存學生影像。</p></div>
    <div className="safety-note">🌱 請站在自己的位置活動，留意身邊同學和物件。</div>
    <div className="row-actions"><button className="text-button" onClick={onBack}>返回</button><button className="big-button primary compact" onClick={onAccept}><Camera/>我明白，開啟鏡頭</button></div>
  </section></main>;
}
